
import {Component, Prop, Vue} from "vue-property-decorator";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import IconBtn from "@/components/molecules/IconBtn.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import DataImplementationInfo from "@/components/organisms/DataImplementationInfo.vue";
import {AssetsDataProfileView, DataProfileView} from "@/components/organisms/DataProfileSource";
import DataImplementationSample from "@/components/organisms/DataImplementationSample.vue";
import {DataImplementation, DataSample} from "@/store/modules/hcs/dataImplementation/model";
import DataProfileSample from "@/components/organisms/DataProfileSample.vue";
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: 'DataProfileInfo',
  components: {
    DataProfileSample,
    DataImplementationSample,
    DataImplementationInfo,
    SimpleDialog,
    IconBtn,
    HdsIdField,
    TextFieldLike
  },
  props: {
    dataProfileView: {
      type: Object as PropType<DataProfileView | AssetsDataProfileView>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideServiceType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataImplementationDialog: false,
      dialogDataSample: {
        visible: false,
        loading: true,
        enabled: false
      }
    }
  },
  computed: {
    showSubtitle() {
      return !!this.$slots['subtitle']?.length;
    },
    dataProfile(): DataProfileView | AssetsDataProfileView | {} {
      return this.dataProfileView ?? {};
    },
    dataImplementation(): DataImplementation | {} {
      if('dataImplementation' in this.dataProfileView) {
        return this.dataProfileView.dataImplementation;
      } else {
        return {};
      }
    },
    dataImplementationId() {
      if('id' in this.dataImplementation) {
        return this.dataImplementation.id ?? null;
      } else {
        return null;
      }
    },
    commonDataComponentModel() {
      return this.dataProfileView?.commonDataComponentModel ?? {};
    },
    localDataComponentModel() {
      if('localDataComponentModel' in this.dataProfileView) {
        return this.dataProfileView.localDataComponentModel;
      } else {
        return {};
      }
    },
  },
  methods: {
    handleLoadedDataSamples(data: DataSample) {
      this.dialogDataSample.loading = false;
      this.dialogDataSample.enabled = data.body.length > 0;
    }
  }
});
